import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  indexRenderMenuDey: false, // Який рендерити день
  menu: {}, //Все меню
};

export const showMenuSlice = createSlice({
  name: 'showMenu',
  initialState,
  reducers: {
    addMenu: (state, { payload }) => {
      const menuKeySort = Object.keys(payload).sort(function (a, b) {
        return payload[a].dayNumber - payload[b].dayNumber;
      });

      const menuSort = {};

      menuKeySort.forEach((itemKey) => {
        menuSort[itemKey] = payload[itemKey];
      });

      state.indexRenderMenuDey = menuKeySort[0];

      state.menu = menuSort;
    },
    // Видаляє меню
    removeMenuRedux: (state, { payload }) => {
      const indexRenderMenuDey = payload.indexRenderMenuDey;
      const newIndexRenderMenuDey = payload.newIndexRenderMenuDey;
      if (newIndexRenderMenuDey) {
        state.indexRenderMenuDey = newIndexRenderMenuDey;
      } else {
        state.indexRenderMenuDey = false;
      }
      delete state.menu[indexRenderMenuDey];
    },

    selectedDey: (state, action) => {
      state.indexRenderMenuDey = action.payload;
    },
  },
});

export const { addMenu, removeMenuRedux, selectedDey } = showMenuSlice.actions;

export default showMenuSlice.reducer;
